import { z } from 'zod/v4';

import { CalculationNodeTypeRuntype } from '../formula-engine';
import { RfqStatus } from '../rfq/rfqBackendTypes';

/**
 * Directly references formula-engine so new node types are included automatically.
 */
export const KPIDatatypeRuntype = z.union([
    CalculationNodeTypeRuntype,
    z.literal('Assembly'),
    z.literal('Rfq'),
    z.literal('ProjectInsights'),
]);
export type KPIDataType = z.infer<typeof KPIDatatypeRuntype>;

export const KPIIdRuntype = z.string();
export type KPIId = z.infer<typeof KPIIdRuntype>;

export const DashboardWidgetIdRuntype = z.string();
export type DashboardWidgetId = z.infer<typeof DashboardWidgetIdRuntype>;

export const QuickActionIdRuntype = z.string();
export type QuickActionId = z.infer<typeof QuickActionIdRuntype>;

export type RfqFilter =
    | { field: 'status'; value: RfqStatus }
    | { field: 'creation_date'; value: 'last_30_days' | 'last_7_days' }
    | { field: 'created_by'; value: string }
    | { field: 'contributor'; value: string }
    | { field: 'is_archived'; value: boolean };

export type RfqFilterGroup = {
    operator: 'And' | 'Or';
    filters: RfqFilter[];
};

export type CountCalculation<F> = {
    type: 'Count';
    filtered_by: F[];
};

export type DeltaCalculation<F> = {
    type: 'Delta';
    filtered_by: F[];
};

export type ShareCalculation<F> = {
    type: 'Share';
    filtered_by: {
        numerator: F[];
        denominator: F[];
    };
    /** Ratio returned when the denominator count is zero. Defaults to 0. */
    emptyDenominatorValue?: number;
};

export type SumCalculation = {
    type: 'Sum';
    filtered_by: undefined;
};

export type KPICalculationType<F> = CountCalculation<F> | DeltaCalculation<F> | ShareCalculation<F> | SumCalculation;
